"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAME_VALUE_DELIMITER = exports.FLAG_DELIMITER = exports.FEATURE_FLAGS_HTTP_HEADER_NAME = void 0;
exports.FEATURE_FLAGS_HTTP_HEADER_NAME = 'mvt-assignment';
exports.FLAG_DELIMITER = '-';
exports.NAME_VALUE_DELIMITER = ':';
